<template>
  <div id="app" v-hotkey="keymap">
    <RouterView />
  </div>
</template>

<script>
import appConfig from '@/app.config';
import CommonMixin from '@/assets/js/common-mixin';

export default {
  name: 'app',
  page: {
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title;
      return title ? `${appConfig.title} | ${title}` : appConfig.title;
    }
  },
  mixins: [ CommonMixin ],
  mounted() {}
}
</script>
